import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Dropdown, Menu } from 'semantic-ui-react';
import { COLORS, Text } from '@cuemath/comps';
import { useHistory, useParams } from 'react-router-dom';
import { stringify } from 'query-string';

import {
  Root,
  CustomeMenu,
  MenuItemStyle,
  DefaultMenu,
  IconMenu,
  VerticleSeperator,
  DefaultMenuItem,
} from './styled-comps';
import { MODAL_FORM } from 'constants/form';
import { DropdownMenu, DropdownItem, DropdownText } from 'comps/dropdown';
import OptionsIcon from 'img/top-bar/options.svg';
import { TEACHER_TAB_MENU } from './tabs';
import { openModal } from 'actions/modal';
import { parse } from 'query-string';
import { useDispatch } from 'react-redux';

function TeacherDetailsTabView() {
  const [menuSelected, setMenuSelected] = useState(false);
  const dispatch = useDispatch();
  const { teacherId } = useParams();
  const history = useHistory();
  const {
    location: { search },
  } = history;

  useEffect(() => {
    const { teacher_tab: teacherTab } = parse(search);
    const tab = teacherTab
      ? TEACHER_TAB_MENU.find(({ path }) => path === teacherTab)
      : TEACHER_TAB_MENU[0];

    const { path } = tab || {};
    if (path) {
      history.replace({
        search: stringify({ teacher_tab: path }),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleItemClick(_e, { name }) {
    history.replace({
      search: stringify({ teacher_tab: name }),
    });
  }

  function getIsActive(name) {
    return search.includes(name);
  }

  const toggleMenu = useCallback(() => {
    setMenuSelected(prevVal => !prevVal);
  }, []);

  const handleOpenAssignCSMModal = useCallback(() => {
    setMenuSelected(false);
    dispatch(
      openModal(
        MODAL_FORM.CSM_ASSIGNMENT_MODAL,
        {
          size: 'custom',
          width: `650px`,
        },
        {
          teacherId,
        },
      ),
    );
  }, []);

  const menuOptions = useMemo(() => {
    return [
      {
        label: 'Assign CSM',
        onClick: handleOpenAssignCSMModal,
      },
    ];
  }, []);

  return (
    <Root flexDirection="row">
      <CustomeMenu pointing secondary>
        {TEACHER_TAB_MENU.map((tab, i) => {
          const isActive = getIsActive(tab.path);
          const menuItemStyles = { ...MenuItemStyle };

          if (isActive) {
            menuItemStyles.color = COLORS.COLA;
          } else {
            menuItemStyles.color = '#2B2B2BBF';
          }

          return (
            <Menu.Item
              key={i}
              style={menuItemStyles}
              name={tab.path}
              active={isActive}
              onClick={handleItemClick}
            >
              <Text color={MenuItemStyle.color}>{tab.name}</Text>
            </Menu.Item>
          );
        })}
      </CustomeMenu>
      <DefaultMenu style={{ margin: 0 }} size="mini" secondary>
        <IconMenu position="right">
          <VerticleSeperator />
          <DefaultMenuItem active={menuSelected} icon>
            <Dropdown
              icon={<img src={OptionsIcon} alt="options_con" />}
              onClick={toggleMenu}
              floating
              onClose={toggleMenu}
              className="icon"
            >
              <DropdownMenu right="-4px">
                {menuOptions?.map(({ label, onClick }) => (
                  <DropdownItem key={label} onClick={onClick}>
                    <DropdownText variant="body1Regular">{label}</DropdownText>
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>
          </DefaultMenuItem>
        </IconMenu>
      </DefaultMenu>
    </Root>
  );
}

export default TeacherDetailsTabView;
